var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-3"},[_c('IconBtn',{attrs:{"icon":"mdi-plus","title":"SubGroup"},on:{"click":_vm.create}})],1),_c('List',{on:{"edit":_vm.edit}}),_c('Form',{ref:"form"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }